import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CircularProgress, Box, Typography } from "@material-ui/core";
import axios from "axios";
import { decryptData } from "../../../crypto";
import UnadacemyQpSyncModal from "./UnadacemyQpSyncModal";

const UnadacemyQpSyncPage = () => {
  const { rowId } = useParams();
  const navigate = useNavigate();
  const [paperCode, setPaperCode] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExamDetails = async () => {
      try {
        const token = decryptData(sessionStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/${rowId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data && response.data.exam) {
          setPaperCode(response.data.exam.paper_code || "");
        }
      } catch (error) {
        console.error("Error fetching exam details for Unacademy QP sync:", error);
      } finally {
        setLoading(false);
      }
    };

    if (rowId) {
      fetchExamDetails();
    } else {
      setLoading(false);
    }
  }, [rowId]);

  const handleClose = () => {
    if (rowId) {
      navigate(`/admin/addquestion/${rowId}`);
    } else {
      navigate(-1);
    }
  };

  if (loading) {
    return (
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          gap: "16px",
        }}
      >
        <CircularProgress style={{ color: "#00577B" }} />
        <Typography variant="body1" color="textSecondary">
          Loading exam configuration...
        </Typography>
      </Box>
    );
  }

  return (
    <UnadacemyQpSyncModal
      open={true}
      handleClose={handleClose}
      paperCode={paperCode}
      rowId={rowId}
      onSuccess={() => {
        navigate(`/admin/addquestion/${rowId}`);
      }}
    />
  );
};

export default UnadacemyQpSyncPage;
